module.exports = __webpack_public_path__ + "img/title-2.9a3e3cca.png";